/*=========================================================================================
  File Name: i18nCA.js
  Description: File đa ngôn ngữ cho phân hệ Quyx
  ----------------------------------------------------------------------------------------
  Project Name: MISA SME Cloud
    Author: pvduong1
  Author URL: http://www.misa.com.vn
==========================================================================================*/


export default {
    QuickAddText: 'Thêm mới (F9)',
    QuickSearchText: 'Tìm nhanh (F3)',
    NumberPerPage: "bản ghi trên",
    Page: "trang",
    First: "Đầu",
    Previous: "Trước",
    Of: "của",
    Next: "Sau",
    Latest: "Cuối",
    TotalItem: "Tổng số bản ghi:",
    ValidateFromDate: "Từ ngày phải nhỏ hơn hoặc bằng Đến ngày",
    ValidateToDate: "Đến ngày phải lớn hơn hoặc bằng Từ ngày",
}